import Upload_File_Service from 'services/account/uploadFile';
import { EventBus } from '../../../../../utils/event-bus';

export const handleUploadImageFile = (filesToUpload, tinyMCE, imageUploader) => {
  try {
    tinyMCE.editorManager.activeEditor.setProgressState(true);
    Upload_File_Service(filesToUpload).then((res) => {
      const location = res.data.aws_url;
      const fr = new FileReader();
      fr.onload = () => {
        const img = new Image();
        img.src = fr.result;
        tinyMCE.insertContent(`<img src="${location}"/>`);
        imageUploader.val('');
        tinyMCE.editorManager.activeEditor.setProgressState(false);
      };
      fr.readAsDataURL(filesToUpload[0]);
    });
  } catch (error) {
    console.error(error);
    EventBus.$emit('createToast', {type: "Error", message: "There was an error uploading the image", time: 5000 });
  }
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Utils/UploadImageFile.js